export default "/img/GH.a4fbd0ede4573655364b69b1a6d7e549.png";